import { PageLoadingIndicator } from 'client/shared/Spinner';
import { History } from 'history';
import React, { useEffect } from 'react';
import { useCurrentUserCtx } from '../../contexts/CurrentUser';
import { localStorage } from '../../modules/Browser/localStorage';

export const IS_EXISTING_USER_KEY = 'isExistingUser';

export function NewEpisodeRedirectScreen({ history }: { history: History }) {
  const {
    state: { status, userId },
  } = useCurrentUserCtx();

  useEffect(() => {
    if (status === 'success') {
      if (userId) {
        history.replace('/dashboard/episode/new');
      } else {
        loggedOutRedirect();
      }
    } else if (status === 'error') loggedOutRedirect();

    function loggedOutRedirect() {
      localStorage
        .getItem(IS_EXISTING_USER_KEY)
        .then(isExistingUser =>
          history.replace(
            `${
              isExistingUser ? '/login' : '/signup'
            }?return_to=%2Fdashboard%2Fepisode%2Fnew`
          )
        );
    }
  }, [status, userId, history]);

  return <PageLoadingIndicator color="#ffffff" />;
}
